// components/VideoPlayer/WordInfoModal/DefinitionSection.jsx

import React, { useState } from "react";
import "./WordInfoModal.css";

const DefinitionSection = ({ enData }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!enData || enData.length === 0) {
    return null;
  }

  return (
    <div className="wim-def">
      <div
        className="wim-def-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h4>English Definitions</h4>
        <span
          className={`wim-def-expand ${
            isExpanded ? "wim-def-expand--open" : ""
          }`}
        >
          <i className="fas fa-chevron-down"></i>
        </span>
      </div>

      {isExpanded && (
        <div className="wim-def-list">
          {enData.map((def, index) => (
            <div key={def._id || index} className="wim-def-item">
              <span className="wim-def-num">{index + 1}.</span>
              <div className="wim-def-body">
                {def.wordtype && (
                  <span className="wim-def-wordtype">({def.wordtype})</span>
                )}
                <span className="wim-def-text">{def.definition}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DefinitionSection;